import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProtectedRoute } from '../schemas/types/shared';

interface ProtectedRouteState {
  name: ProtectedRoute;
}

const initialState: ProtectedRouteState = {
  name: undefined
};

const protectedRouteSlice = createSlice({
  name: 'protectedRoute',
  initialState,
  reducers: {
    setProtectedRoute: (
      state,
      action: PayloadAction<ProtectedRoute | undefined>
    ) => {
      state.name = action.payload;
    },
    clearProtectedRoute: state => {
      state.name = undefined;
    }
  }
});

export const { setProtectedRoute, clearProtectedRoute } =
  protectedRouteSlice.actions;
export default protectedRouteSlice.reducer;
